import { RefObject, useEffect } from "react";

/**
 * @description use like below
 * import React, { useRef } from 'react'
 * const Wrap = () => {
 *   const ref = useRef()
 *   useHoverOutside(ref, () => callback, isTrigger?:boolean)
 *   return <Element ref={ref} />
 * }
 */

export function useHoverOutside(
  ref: RefObject<any> | RefObject<any>[],
  callback,
  isTrigger = true,
  dep: any[] = []
) {
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (Array.isArray(ref)) {
        if (ref.every((r) => r && r.current && !r.current.contains(e.target))) {
          callback();
        }
      } else {
        ref && ref.current && !ref.current.contains(e.target) && callback();
      }
    };
    if (isTrigger) {
      document.addEventListener("mouseover", handleClickOutside);
      return () => {
        document.removeEventListener("mouseover", handleClickOutside);
      };
    }
  }, [isTrigger, ...dep]);
}
